import { createRoute, lazyRouteComponent, Navigate } from "@tanstack/react-router";

import { appLayoutRoute } from "../../router/rootRoutes";
import { discoverySearchSchema } from "./routeSearch";

const discoverRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/discover",
  component: () => <Navigate to="/discover/$scope" params={{ scope: "trending" }} search={{}} />,
});

const discoveryScopeRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/discover/$scope",
  validateSearch: discoverySearchSchema,
  component: lazyRouteComponent(() => import("./DiscoveryPage"), "DiscoveryPage"),
});

const showDetailsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/shows/$showId",
  component: lazyRouteComponent(() => import("./ShowDetailsPage"), "ShowDetailsPage"),
});

const episodeDetailsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/shows/$showId/episodes/$episodeId",
  component: lazyRouteComponent(() => import("./EpisodeDetailsPage"), "EpisodeDetailsPage"),
});

export const catalogRoutes = [
  discoverRoute,
  discoveryScopeRoute,
  showDetailsRoute,
  episodeDetailsRoute,
] as const;
